import { gql } from 'graphql-request';

const UpdateSettlementQuery = gql`
  mutation UpdateSettlement(
    $settlementId: Int!, 
    $userContractId: Int!, 
    $input: SettlementInput!
  ) {
    UpdateSettlement(
      settlementId: $settlementId, 
      userContractId: $userContractId, 
      input: $input
    ) {
      status
      error
      messege
      data
    }
  }
`;
export default UpdateSettlementQuery;
